import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container container-xs main-wrap" }
const _hoisted_2 = { class: "p-5" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"card\"><div class=\"card-body\"><h2 class=\"title\">TACアプリケーション利用規約</h2><p style=\"font-size:0.9em;\"> ＴＡＣ株式会社（以下、当社といいます）が提供する各種資格試験対策にかかるアプリケーション（以下、本アプリといいます）をご利用いただく際の条件を定めるものであり、利用者が当規約に同意していない場合は、本アプリを利用できず、直ちに本アプリのダウンロード、インストールまたは利用を中止してください。なお、本アプリをダウンロード、インストールまたは利用する場合、利用者は当規約に同意したものとみなします。 <br>１．目的 <br>ＴＡＣアプリケーション利用規約（以下、当規約といいます）は、第２条に定める利用者が所有または管理する対応端末にて本アプリを利用するにあたり、その権利義務、利用条件を定めることを目的とします。 <br>２．定義 <br>当規約に定める利用者とは、本アプリを有償にて購入した者のほか、当社が提供する各種資格試験対策に関するサービスまたは商品を購入した者、その他の特典として利用を許可された者をいいます。 <br>３．使用の範囲 <br>（１）利用者は、利用者自身が利用する場合にのみ本アプリを使用することができるものとし、利用者自身の責任と費用でこれを使用するものとします。 <br>（２）本アプリは、利用者が所有または管理する使用可能な対応端末でのみ利用することができるものとします。 <br>４．利用料金（有償の場合） <br>本アプリの利用料金は、別途申込書等に記載する当社が定める金額とします。利用者はそこで定められた利用料金を当社が定める時期までに支払うものとします。 <br>５．禁止事項 <br>利用者は、本アプリの利用にあたり、次に掲げる行為を行ってはならないものとします。 <br>① 第１条に定める目的以外での使用 <br>② 本アプリの商業的利用及び二次的利用 <br>③ 本アプリの全部または一部の複製、編集、改変、解析、公開、頒布、販売、譲渡、貸与、公衆送信、転載、出願等その他の利用 <br>④ 法令、公序良俗または本規約に違反する行為 <br>６．著作権等の知的財産権 <br>本アプリに係る著作権等の知的財産権その他の権利は、当社または当社に対して使用許諾を行っている第三者に帰属します。本規約による利用者への本アプリの使用許諾は、利用者に対する何らの権利移転等を意味するものではありません。 <br>７．免責事項 <br>（１）本アプリの利用にあたり、当社の故意または重大な過失によるもの以外で生じた損害、及び第三者から利用者に対してなされた損害賠償請求に基づく損害については一切の責任を負いません。 <br>（２）利用者が使用する対応端末は、利用者の費用と責任において準備するものとし、当社は、通信環境の不備等による本アプリの使用障害については、一切サポートを行いません。 <br>（３）当社は、本アプリの正確性、健全性、適用性、有用性、動作保証、対応端末への適合性、その他一切の事項について保証しません。 <br>（４）各種本試験の申込、試験申込期間などは、必ず利用者自身で確認するものとし、いかなる損害が発生した場合であっても当社では一切の責任を負いません。 <br>８．本アプリ及び当規約の成立、変更、終了 <br>（１）当規約は、利用者が本アプリをダウンロード、インストールまたは利用を開始した時点をもって、成立し、効力を生じるものとします。 <br>（２）当社は、当規約の変更が生じた場合には、当社ホームページにて告知します（<a href=\"https://www.tac-school.co.jp/terms.html\" target=\"_blank\">https://www.tac-school.co.jp/terms.html</a>）。 <br>（３）当規約が終了した場合には、利用者はいかなる理由においても本アプリを利用することはできず、自己の占有または管理下にある本アプリ（当規約に違反して複製された複製物を含む）を全て速やかに破棄または消去するものとします。 <br>９．準拠法及び裁判管轄 <br>（１）当規約は、日本法に準拠し同法に基づいて解釈されるものとします。 <br>（２）当規約に関連する訴訟の必要が生じた場合は、東京地方裁判所または東京簡易裁判所を第一審の専属的合意管轄裁判所とします。 <br>2025年1月1日 <br>ＴＡＣ株式会社 <br>①注意事項 <br>・この模擬試験プログラムは、該当の書籍を購入された方の試験対策用です。該当の書籍をご購入されていない方の模擬試験プログラムの実行は固くお断りします。 <br>・採点は、当社の作成した模範解答を基準に行っています。 <br>・問題内容についてのご質問などはお受けしておりません。 <br>②推奨環境 <br>【推奨デバイス】 <br>PC・タブレット <br>【推奨ブラウザ】 <br>・Microsoft Edge 最新版 <br>・Google Chrome 最新版 <br>・Safari最新版 </p></div></div>", 1)
const _hoisted_4 = { class: "text-center my-5" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("上記に同意して本アプリを使用する ")
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "mb-3 text-center" }, "購入書籍を選択し書籍に記載のパスワードを入力してください。", -1)
const _hoisted_8 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_9 = { class: "text-center mb-5 mt-3" }
const _hoisted_10 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", null, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isCheck) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.isCheck]
            ]),
            _hoisted_5
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            class: "form-control mx-auto",
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.answer) = $event)),
            style: {"width":"450px"}
          }, null, 512), [
            [_vModelText, _ctx.answer]
          ]),
          (_ctx.isError)
            ? (_openBlock(), _createElementBlock("small", _hoisted_8, "正しいパスワードを入力してください"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            class: "f-md btn btn-secondary",
            style: {"width":"200px"},
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.answerQa && _ctx.answerQa(...args))),
            disabled: !_ctx.isCheck
          }, "送信", 8, _hoisted_10)
        ])
      ])
    ])
  ]))
}